import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import './uploadSurveyPoints.scss';
import { useEffect } from 'react';
import { Alert } from '../../common/Alert/Alert';
import { UploadSurveyPointsVM } from './UploadSurveyPointsVM';
import stores from 'cd-eft/models/Stores';
import { UploadFile } from 'cd-eft/components/common/UploadFile/UploadFile';
const setStore = stores.AppStore.surveyEngineeringStore;
const designStore = stores.AppStore.designStore;

const UploadSurveyPointsComponent = (props) => {
  const vm = useRef(new UploadSurveyPointsVM(props)).current;

  useEffect(() => {
    if (!designStore.currentSurface.surfaceDefId) {
      // vm.hasNoSurface();
      setStore.isHeaderAccepted = true; //disable the upload icon as there is no surface
    }
  }, [designStore.currentSurface.surfaceDefId]);
  return (
    <>
      {vm.error && <Alert show={vm.error} type="error" msg={vm.errorMsg} />}
      <div id="uploadFile">
        <UploadFile
          disabled={setStore.isHeaderAccepted}
          fileType=".csv"
          id="upload-box"
          name="file"
          className={setStore.isHeaderAccepted ? 'upload-file-disabled' : ''}
          iconColor={setStore.isHeaderAccepted ? 'grey' : '#005ea2'}
          onChange={(e) => vm.fileUpload(e)}
          onClick={(e) => {
            const target: any = e.target;
            target.value = null;
          }}
        />
      </div>
    </>
  );
};

export const UploadSurveyPoints = observer(UploadSurveyPointsComponent);
